export enum Roles {
  SUPER_ADMIN = 'Super admin',
  PROFILE_MANAGER = 'Profile manager',
  CONTENT_MANAGER = 'Content manager',
  MAINTAINER = 'Maintainer',
  RESELLER = 'Reseller',
}
